import { PageStore } from 'bernie-core';

export enum PageId {
  FIGHTS_SEARCH_ONE_WAY = 'page.Flight-Search-Oneway,F,20',
  FIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND = 'page.Flight-Search-Roundtrip.Out,F,20',
  FIGHTS_SEARCH_ROUND_TRIP_IN_BOUND = 'page.Flight-Search-Roundtrip.In,F,20',
  FIGHTS_SEARCH_MULTI_LEG_0 = 'page.Flight-Search-MDest.Leg0,F,20',
  FIGHTS_SEARCH_MULTI_LEG_1 = 'page.Flight-Search-MDest.Leg1,F,20',
  FIGHTS_SEARCH_MULTI_LEG_2 = 'page.Flight-Search-MDest.Leg2,F,20',
  FIGHTS_SEARCH_MULTI_LEG_3 = 'page.Flight-Search-MDest.Leg3,F,20',
  FIGHTS_SEARCH_MULTI_LEG_4 = 'page.Flight-Search-MDest.Leg4,F,20',
  FIGHT_INFORMATION = 'page.Flight.Ratedetails,F,30'
}

export const FightsSearchPageIds: { [key: string]: string } = {
  ONE_WAY_0: PageId.FIGHTS_SEARCH_ONE_WAY,
  ROUND_TRIP_0: PageId.FIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND,
  ROUND_TRIP_1: PageId.FIGHTS_SEARCH_ROUND_TRIP_IN_BOUND,
  MULTI_DESTINATION_0: PageId.FIGHTS_SEARCH_MULTI_LEG_0,
  MULTI_DESTINATION_1: PageId.FIGHTS_SEARCH_MULTI_LEG_1,
  MULTI_DESTINATION_2: PageId.FIGHTS_SEARCH_MULTI_LEG_2,
  MULTI_DESTINATION_3: PageId.FIGHTS_SEARCH_MULTI_LEG_3,
  MULTI_DESTINATION_4: PageId.FIGHTS_SEARCH_MULTI_LEG_4
};

export const isFightInformation = (page: PageStore) => page.pageId === PageId.FIGHT_INFORMATION;
export const isFightsSearch = (page: PageStore) => !isFightInformation(page);
